import styled from "styled-components";
import Width from "../Width";
import { useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

const FooterBlock = styled.div`
  width: 100%;
  font-size: 12px;
  padding-top: 40px;
  color: #999;
  margin-bottom: 80px;
`;

const COMPANY_NAME = "%Компания%";
const COMPANY_DETAILS = "%Реквизиты компании%";
const COMPANY_URL = "%Адрес%";

const FooterComponent = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const [policyPopup, setPolicyPopup] = useState(false);

  return (
    <FooterBlock>
      <Width>
        <Box>
          © 2011 – {year} {COMPANY_NAME}
        </Box>

        <Box sx={{ my: 1 }}>
          <Button
            onClick={() => setPolicyPopup(true)}
            variant="text"
            sx={{ px: 0, textTransform: "none", fontSize: "12px" }}
            size="small"
          >
            {t("footer.privacyPolicy")}
          </Button>
        </Box>

        <p>
          {COMPANY_NAME} {COMPANY_DETAILS}
        </p>

        <p>{t("footer.riskNotice")}</p>
        <p>1. {t("footer.risk1")}</p>
        <p>2. {t("footer.risk2")}</p>
        <p>3. {t("footer.risk3")}</p>
        <p>4. {t("footer.risk4")}</p>

        <p>
          {t("footer.activityDisclosure", {
            company: COMPANY_NAME,
            url: COMPANY_URL,
          })}
        </p>
      </Width>

      <Dialog
        open={policyPopup}
        onClose={() => setPolicyPopup(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          {t("footer.privacyPolicyTitle", { company: COMPANY_NAME })}
        </DialogTitle>
        <DialogContent>
          <p>%Политика конфиденциальности%</p>
        </DialogContent>
      </Dialog>
    </FooterBlock>
  );
};

export default FooterComponent;
